package com.example.monetix.db

import kotlin.Boolean
import kotlin.Long
import kotlin.String

public data class TransactionEntity(
  public val id: String,
  public val accountId: String?,
  public val toAccountId: String?,
  public val fromAccountId: String?,
  public val amountCents: Long,
  public val type: String,
  public val dateEpochDay: Long,
  public val categoryId: String,
  public val description: String?,
  public val merchantKey: String?,
  public val subcategoryText: String?,
  public val logoEmoji: String?,
  public val logoUri: String?,
  public val isHidden: Boolean,
  public val isDeleted: Boolean,
  public val reminderDays: Long?,
  public val createdAtEpochMs: Long,
  public val updatedAtEpochMs: Long,
)
